<template>
  <Navbar />
  <router-view></router-view>
  <vue-progress-bar></vue-progress-bar>
  <Footer />
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import { onMounted, getCurrentInstance } from "vue";
import VueProgressBar from "@aacassandra/vue3-progressbar";

export default {
  name: "App",
  components: {
    Navbar,
    Footer,
  },
  setup() {
    const internalInstance = getCurrentInstance();
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    internalInstance.appContext.config.globalProperties.$Progress.start();
    onMounted(() => {
      window.scrollTo(0, 0);
      internalInstance.appContext.config.globalProperties.$Progress.finish();
    });
  },
};
</script>
<style>
:root {
  /* color schema */
  --Outer-Space: #454545;
  --Ultramarine-Blue: #3e64ff;
  --Cerulean: #01aef2;
  --Sky-Blue: #5edfff;
  --grayish-white: #f7f8fd;
  --Celeste: #b2fcff;
  --Coral: #54616c;
  --snow-white: #f9fafd;
  --gray: #b5b5b5;
  --Ghost-White: #f7f8fd;
  --Azure: #ecfcff;
  --white: #fff;

  /* border radius */
  --br-100: 100px;

  /* padding */
  --p-sm: 10px 24px;
  --p-md: 18px 40px;

  /* margin */
  --ml-32: 32px;

  /* font size */
  --fs-60: 60px;
  --fs-48: 48px;
  --fs-32: 32px;
  --fs-20: 20px;
  --fs-16: 16px;
  --fs-22: 22px;
  --fs-14: 14px;

  /* font family */
  --ff-roboto: "Roboto", sans-serif;
  --ff-poppins: "Poppins", sans-serif;
  --ff-openSans: "Open Sans", sans-serif;

  /* font-weight */
  --fw-700: 700;
  --fw: 400;

  --bs: 0px 0px 4px 0px #45454540;
}
* {
  font-family: var(--ff-poppins, --ff-openSans);
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  overflow-x: hidden;
}

/* BUTTON COMPONENT */
.btn-sm {
  padding: var(--p-sm) !important;
  background-color: var(--Cerulean);
  font-size: var(--fs-16);
  font-weight: var(--fw-700);
  border-radius: var(--br-100);
  color: var(--white);
}
.btn-md {
  padding: var(--p-md) !important;
  background-color: var(--Cerulean);
  font-size: var(--fs-16);
  font-weight: var(--fw-700);
  border-radius: var(--br-100);
  color: var(--white);
  box-sizing: border-box !important;
}
</style>
